export interface DriverLimitsConfig {
  maxTotal: number;
  maxAdditional: number;
}

export interface DriverSelectionOption {
  key: string;
  text: string;
  showsAdditionalDrivers: boolean;
}

export type DriverSelectionType = 'buttons' | 'radio' | 'dropdown';

export interface DriverSelectionConfig {
  type: DriverSelectionType;
  prompt: string;
  options: DriverSelectionOption[];
}

export interface QuestionCondition {
  field: string;
  value: any;
}

export interface AgreementQuestion {
  id: string;
  text: string;
  required: boolean;
  showWhen?: QuestionCondition;
}

export interface DrivingQuestionsConfig {
  driverLimits: DriverLimitsConfig;
  driverSelection?: DriverSelectionConfig; // Make optional
  additionalDrivers: {
    prompt: string;
    addButtonText: string;
    maxReachedMessage: string;
  };
  questions: AgreementQuestion[];
}

export const validateDrivingQuestionsConfig = (config: any): config is DrivingQuestionsConfig => {
  if (!config || typeof config !== 'object') return false;
  
  const { driverLimits, driverSelection, additionalDrivers, questions } = config;
  
  // Validate driverLimits
  if (!driverLimits || typeof driverLimits.maxTotal !== 'number' || driverLimits.maxTotal < 1) {
    return false;
  }
  
  if (typeof driverLimits.maxAdditional !== 'number' || driverLimits.maxAdditional < 0) {
    return false;
  }
  
  if (driverLimits.maxAdditional >= driverLimits.maxTotal) {
    return false;
  }
  
  // Validate driverSelection
  if (!driverSelection || !Array.isArray(driverSelection.options) || driverSelection.options.length === 0) {
    return false;
  }
  
  // Validate questions
  if (!Array.isArray(questions)) {
    return false;
  }
  
  return true;
};

export const resolveTemplateString = (template: string, config: DrivingQuestionsConfig): string => {
  return template
    .replace('{maxTotal}', config.driverLimits.maxTotal.toString())
    .replace('{maxAdditional}', config.driverLimits.maxAdditional.toString());
};

export const shouldShowQuestion = (question: AgreementQuestion, reservationData: any): boolean => {
  if (!question.showWhen) return true;
  
  const { field, value } = question.showWhen;
  return reservationData[field] === value;
};
